import { useEffect, useState } from "react";
import {
  catchAsync,
  changePageToOne,
  checkResponse,
} from "../utilities/utilities";
import { defaultDeleteModelState } from "../utilities/const";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const dataHandler = ({ api, extraBody, dataToSet, dependencyArr = [], orderBy = "hotelName", limit = 10 }) => {
  // console.log("dataHandler api", api);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMounted, setIsMounted] = useState(false);
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [total, setTotal] = useState(0);
  const [deleteModel, setDeleteModel] = useState(defaultDeleteModelState);

  const [body, setBody] = useState({
    search: "",
    status: "",
    page: 1,
    // orderBy: 1,
    limit,
    orderBy,
    sortOrder: 1,
    ...extraBody,
  });

  const getData = catchAsync(async (body) => {
    setLoader(true);
    const nb={...body}
    if(!nb.search) delete nb.search
    if(!nb.status) delete nb.status
    const res = await api(nb);
    checkResponse({
      res,
      setData,
      setLoader,
      setTotal,
      dataToSet,
    });
  }, setLoader);

  const refetch = () => {
    const newBody = changePageToOne(body, setBody);
    getData(newBody);
  };

  let oldData;
  const statusChangeCallBack = () => {
    setData((p) => oldData);
  };
  const statusChangeHandler = catchAsync(
    async (api, key) => {
      oldData = JSON.parse(JSON.stringify(data));

      setData((p) => {
        const newArr = JSON.parse(JSON.stringify(p));
        newArr[key].status =
          newArr[key]?.status === "Active" ? "Block" : "Active";
        return newArr;
      });

      const res = await api();
      checkResponse({ res, showSuccess: true });
    },
    null,
    statusChangeCallBack
  );

  const deleteHandler = catchAsync(async (api) => {
    const res = await api();
    const success = checkResponse({ res, showSuccess: true });
    setDeleteModel({ show: false, dumpId: "" });
    if (success) {
      refetch();
    }
    return success;
  });

  const paginationHandler = (page) => {
    setBody((prev) => ({ ...prev, page }));

    // Persist page in URL
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const searchHandler = () => {
    const newBody = { ...body, page: 1, search: body.search.trim() };
    setBody((p) => newBody);
    getData(newBody);
  };

  // useEffect(() => {
  //   if (body?.search?.trim() === "") {
  //     setIsMounted((p) => true);
  //     refetch();
  //   }
  // }, [body.search]);

  const depArr = [
    body.limit,
    body.page,
    body.eventType,
    body.status,
    body.orderStatus,
    body.type,
    body.country,
    body.address,
    body.startDate,
    body.endDate
  ];

  dependencyArr.forEach((element) => {
    depArr.push(body[element]);
  });

  useEffect(() => {
    if (isMounted) return;
    const queryPage = new URLSearchParams(location.search).get("page");
    setBody((p) => ({ ...p, page: Number(queryPage || 1) }));
    if (Number(queryPage || 1) == 1) {
      refetch();
    }
    setIsMounted((p) => true);
  }, []);

  useEffect(() => {
    if (!isMounted) return;
    getData(body);
  }, [api, ...depArr]);


  useEffect(() => {
    if (!isMounted) return;
    getData({
      ...body,
      orderBy,
      limit
    })
  }, [orderBy, limit]);


  return {
    data,
    setData,
    body,
    setBody,
    loader,
    setLoader,
    total,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    refetch,
    getData,
    statusChangeHandler,
    deleteHandler,
  };
};

export default dataHandler;
